import http from "../http-common";

class EmailDataService {
    sendMail(data) {
        return http.post("/mail", data);
    }

    sendMailMutuo(data) {
        return http.post("/mail/mutuo", data);
    }
}

export default new EmailDataService();